import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import React from 'react'
import { BankAccountTypeEnum, ProfileAccountTypes } from '../types'

export const ProfileAccountTypeRadios: React.FC<{
  onIsAchDebit: (event: React.ChangeEvent<HTMLInputElement>) => void
  isAchDebit: boolean
}> = ({ onIsAchDebit, isAchDebit }) => (
  <RadioGroup
    row
    aria-labelledby="demo-row-radio-buttons-group-label"
    name="row-radio-buttons-group"
    onChange={onIsAchDebit}
    value={
      isAchDebit
        ? ProfileAccountTypes.BANK_ACCOUNT
        : ProfileAccountTypes.CREDIT_CARD
    }
  >
    <FormControlLabel
      value={ProfileAccountTypes.CREDIT_CARD}
      control={<Radio color="success" />}
      label={
        <Typography
          sx={{
            fontWeight: !isAchDebit ? 'bold' : 'normal',
            color: !isAchDebit ? 'green' : 'inherit',
          }}
        >
          Credit Card
        </Typography>
      }
    />
    <FormControlLabel
      value={ProfileAccountTypes.BANK_ACCOUNT}
      control={<Radio color="success" />}
      label={
        <Typography
          sx={{
            fontWeight: isAchDebit ? 'bold' : 'normal',
            color: isAchDebit ? 'green' : 'inherit',
          }}
        >
          Bank Account
        </Typography>
      }
    />
  </RadioGroup>
)

export const ProfileBankAccountTypeRadios: React.FC<{
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  value: BankAccountTypeEnum
}> = ({ onChange, value }) => (
  <RadioGroup
    row
    aria-labelledby="bank-radio-buttons-group-label"
    name="bank-radio-buttons-group"
    onChange={onChange}
    value={value}
  >
    <FormControlLabel
      value={BankAccountTypeEnum.CHECKING}
      control={<Radio />}
      label="Checking"
    />
    <FormControlLabel
      value={BankAccountTypeEnum.BUSINESSCHECKING}
      control={<Radio />}
      label="Business Checking"
    />
    <FormControlLabel
      value={BankAccountTypeEnum.SAVINGS}
      control={<Radio />}
      label="Savings"
    />
  </RadioGroup>
)
